import React from 'react';
import {connect} from 'react-redux';
import {ReactSVG} from 'react-svg';
import {
    activateLayer,
    displayLayerInfoPopup,
    displayOpacitySlider,
    updateMapProperties,
    zoomMapToExtent
} from '../../../actions';

class NavbarLayerItem extends React.Component {
    constructor(props) {
        super(props);
        if (this.props.type === 'radio') {
            this.layerType = 'radio-like';
            this.icon = <div></div>;
        } else {
            this.layerType = 'checkbox-like';
            this.icon = <ReactSVG className="checkbox-icon react-svg" src="/img/maps/icon/checkbox.svg"/>
        }
    }

    render() {
        const layerInfoPopupPayload = {
            status: true,
            data: [],
        };
        const active = this.props.activeLayers.includes(this.props.layer);

        return (
            <div className="dropdown-item layer-item-container">
                <div className={`layer-form-check ${active ? 'active' : ''}`}
                     onClick={() => {
                         this.props.activateLayer(this.props.layer);
                         this.props.displayOpacitySlider({status: false});
                     }}
                >
                    <div className={this.layerType}>
                        {this.icon}
                    </div>
                    <div className="form-check-label">
                        <span>
                            {this.props.title}
                        </span>
                    </div>
                </div>
                {this.props.layer.content ?
                    <div className="layer-info">
                        <a href="#" className="layer-info-button"
                           onClick={() => this.props.displayLayerInfoPopup({
                               status: true,
                               data: this.props.layer.content
                           })}
                        >
                            <ReactSVG className="layer-info-icon react-svg" src="/img/maps/icon/info.svg"/>
                        </a>
                    </div>
                : <div className="layer-info"></div> }

            </div>
        );
    }
}

const mapActionToProps = {
    updateMapProperties,
    zoomMapToExtent,
    displayLayerInfoPopup,
    activateLayer,
    displayOpacitySlider,
};

const mapStateToProps = state => {
    return {
        layers: state.layers,
        activeLayers: state.activeLayers,
        layerInfoPopupData: state.layerInfoPopupData
    };
};

export default connect(mapStateToProps, mapActionToProps)(NavbarLayerItem);